// Case-insensitive, number-aware name comparison used to alphabetise team/team-member
// lists. `numeric: true` compares digit runs by value, so "02" < "10" and "01-Dawood"
// sorts before "Ali" (digits come before letters in locale collation).
const collator = new Intl.Collator(undefined, { sensitivity: "base", numeric: true });

export const compareByName = (a, b) => collator.compare(String(a ?? ""), String(b ?? ""));

// Returns a new sorted array (never mutates the input — Redux state is frozen).
export const sortByName = (list, getName = (x) => x?.name) =>
  [...(Array.isArray(list) ? list : [])].sort((a, b) => compareByName(getName(a), getName(b)));
